import { useCallback } from "react";

export const useEditHTML = () => {
  const handleEditHTML = useCallback(async (html: string): Promise<string> => {
    if (!html) {
      return "";
    }

    const floatConfigs: Record<string, string> = {
      "__se__float-none":
        "margin:auto !important; padding:1px; max-width: 100%;",
      "__se__float-center":
        "margin:auto !important; padding:1px; max-width: 100%;",
      "__se__float-right":
        "margin:auto !important; float: right; padding:1px; max-width: 100%;",
      "__se__float-left":
        "margin:auto !important; float: left; padding:1px; max-width: 100%;",
    };
    let updatedHtml = html;
    Object.entries(floatConfigs).forEach(([floatClass, marginStyle]) => {
      const divRegex = new RegExp(
        `<div[^>]*class=["'][^"']*se-component se-image-container ${floatClass}[^"']*["'][^>]*>([\\s\\S]*?)<\\/div>`,
        "g",
      );

      updatedHtml = updatedHtml.replace(divRegex, (divMatch) => {
        return divMatch.replace(
          /<figure([^>]*)>/g,
          (figureMatch, figureAttrs) => {
            // Se già c'è lo style
            if (/style=["'][^"']*["']/.test(figureAttrs)) {
              return `<figure${figureAttrs.replace(
                /style=["']([^"']*)["']/,
                (m: any, styleContent: string) => {
                  // Evita doppioni
                  if (styleContent.includes(marginStyle.trim()))
                    return `style="${styleContent}"`;
                  return `style="${styleContent.trim().replace(/;?$/, ";")} ${marginStyle}"`;
                },
              )}>`;
            } else {
              // Se non c’è style, aggiungilo
              return `<figure${figureAttrs} style="${marginStyle}">`;
            }
          },
        );
      });
    });

    updatedHtml = updatedHtml.replace(/<table([^>]*)>/g, (match, attrs) => {
      if (/style=["'][^"']*["']/.test(attrs)) {
        return `<table${attrs.replace(
          /style=["']([^"']*)["']/,
          (m: any, styleContent: string) => {
            if (styleContent.includes("width: 100%"))
              return `style="${styleContent}"`;
            return `style="${styleContent.trim().replace(/;?$/, ";")} width: 100%;"`;
          },
        )}>`;
      } else {
        return `<table${attrs} style="width: 100%;">`;
      }
    });

    updatedHtml = updatedHtml.replace(
      /<table([^>]*)class=["'][^"']*se-table-layout-fixed[^"']*["'][^>]*>/g,
      (match, attrs) => {
        if (/style=["'][^"']*["']/.test(attrs)) {
          return `<table${attrs.replace(
            /style=["']([^"']*)["']/,
            (m: any, styleContent: string) => {
              if (styleContent.includes("table-layout: fixed")) {
                return `style="${styleContent}"`;
              }
              return `style="${styleContent.trim().replace(/;?$/, ";")} table-layout: fixed !important;"`;
            },
          )}>`;
        } else {
          return `<table${attrs} style="table-layout: fixed !important;">`;
        }
      },
    );

    // updatedHtml = updatedHtml.replace(
    //     /<img([^>]*)>/g,
    //     (match, attrs) => {
    //         if (/style=["'][^"']*["']/.test(attrs)) {
    //             return `<img${attrs.replace(
    //                 /style=["']([^"']*)["']/,
    //                 (m: any, styleContent: string) => {
    //                     if (styleContent.includes("max-width")) return `style="${styleContent}"`;
    //                     return `style="${styleContent.trim().replace(/;?$/, ';')} max-width:100%; height:auto; display:block;"`;
    //                 }
    //             )}>`;
    //         } else {
    //             return `<img${attrs} style="max-width:100%; height:auto; display:block;">`;
    //         }
    //     }
    // );

    return updatedHtml;
  }, []);
  return handleEditHTML;
};

export const useAddBackground = () => {
  const handleAddBackground = useCallback(
    async (
      html: string,
      backgroundUrl: string = "",
      mode: string,
    ): Promise<string> => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");

      const className =
        mode === "landscape" ? "background-landscape" : "background-portrait";

      const width = mode === "landscape" ? "296mm" : "210mm";
      const height = mode === "landscape" ? "209mm" : "297mm";

      const styleValue = `
    background-image: url('${backgroundUrl}');
    background-size: cover;
    background-position: center;
    width: ${width};
    height: ${height};
    margin: 0;
  `;

      let backgroundDiv = doc.querySelector<HTMLDivElement>(
        ".background-portrait, .background-landscape",
      );

      if (backgroundDiv) {
        backgroundDiv.className = className;
        backgroundDiv.setAttribute("style", styleValue);
      } else {
        backgroundDiv = doc.createElement("div");
        backgroundDiv.className = className;
        backgroundDiv.setAttribute("style", styleValue);

        while (doc.body.firstChild) {
          backgroundDiv.appendChild(doc.body.firstChild);
        }

        doc.body.appendChild(backgroundDiv);
      }

      const styleEl = doc.createElement("style");
      styleEl.setAttribute("type", "text/css");
      styleEl.innerHTML = `
    @page {
      margin: 0;
      size: a4 ${mode};
    }

    html, body {
      margin: 0;
      padding: 0;
      width: ${width};
      height: ${height};
    }

    .background-portrait, .background-landscape {
      padding: 16px;
 	    box-sizing: border-box;
      width: ${width};
      height: ${height};
    }

    .background-portrait img, .background-landscape img {
      width: 100%;
      height: auto;
      display: block;
    }
  `;

      doc.querySelectorAll("style").forEach((el) => {
        if (el.textContent?.includes("@page")) el.remove();
      });

      const head = doc.querySelector("head") || doc.createElement("head");
      if (!doc.querySelector("head")) {
        doc.documentElement.prepend(head);
      }
      head.appendChild(styleEl);

      return "<!DOCTYPE html>\n" + doc.documentElement.outerHTML;
    },
    [],
  );
  return handleAddBackground;
};
